/*
 * -----------------------------------------------------------------------
 *  <copyright file="lovs-grid.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import { orderBy } from '@progress/kendo-data-query';
import React, { useEffect, useState } from 'react';
import { useTranslation, useGridCells } from 'hooks';
import { restructuredUpdatedCreatedBy } from '@utils-clean/update-users-array';
import ExpandableGrid from 'views/components/core/expandable/grid';
import { GridColumnMenuActiveFilter } from 'views/components/core/grid-filters';

import './styles.scss';

const LOVsGrid = ({ lovs, rowActions }: any) => {
    const { t } = useTranslation();
    const orderedLovs = orderBy(lovs, [{ field: 'typeLabel', dir: 'asc' }]);
    const data = restructuredUpdatedCreatedBy(orderedLovs);
    const { MaxLengthCell } = useGridCells();
    const { YesNoCell, DateCell } = useGridCells();

    return (
        <ExpandableGrid
            customKey="lovs-grid"
            id="lovs-grids"
            rowActions={rowActions}
            groupable={false}
            showPager
            scrollable="scrollable"
            reorderable
            pageable={false}
            addScroll
            resizable
            options={{
                allowExcelExport: false,
                allowExpandCollapseAll: false,
                useFilterChips: true,
            }}
            items={data}
            columns={[
                {
                    label: t('common:active'),
                    field: 'active',
                    id: 'lov-active',
                    minWidth: 140,
                    cells: { data: YesNoCell },
                    filterUi: GridColumnMenuActiveFilter,
                    lockedByDefault: true,
                },
                {
                    label: t('admin:listName'),
                    field: 'typeLabel',
                    id: 'lov-name',
                    minWidth: 190,
                    lockedByDefault: true,
                },
                {
                    label: t('admin:listDescription'),
                    field: '_lovDescription',
                    id: 'lov-description',
                    minWidth: 190,
                    lockedByDefault: true,
                },
                {
                    label: t('common:value'),
                    field: 'name',
                    id: 'lov-value',
                    minWidth: 140,
                    lockedByDefault: true,
                },
                {
                    label: t('ra:comments'),
                    field: 'comments',
                    id: 'lov-comments',
                    minWidth: 160,
                    cells: { data: MaxLengthCell(150) },
                },
                {
                    label: t('ra:createdBy'),
                    field: '_createdByString',
                    id: 'lov-createdby',
                    minWidth: 200,
                },
                {
                    label: t('ra:createdDate'),
                    field: 'created',
                    id: 'lov-created',
                    filter: 'date',
                    minWidth: 200,
                    cells: { data: DateCell },
                },
                {
                    label: t('ra:updatedBy'),
                    field: '_updatedByString',
                    id: 'lov-updatedby',
                    minWidth: 200,
                },
                {
                    label: t('ra:updatedDate'),
                    field: 'updated',
                    id: 'lov-updated',
                    filter: 'date',
                    minWidth: 200,
                    cells: { data: DateCell },
                },
            ]}
        />
    );
};

export default LOVsGrid;
